var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecorativeGreenery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_18110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9284 67.857V31.6665M33.9284 33.9284V47.4998M33.9284 33.9284C33.9284 29.1292 32.0219 24.5266 28.6284 21.1331C25.2349 17.7396 20.6323 15.8331 15.8331 15.8331H2.26172V29.4046C2.26172 34.2037 4.16818 38.8063 7.56169 42.1998C10.9552 45.5934 15.5578 47.4998 20.357 47.4998H33.9284M33.9284 33.9284H47.4998C52.299 33.9284 56.9016 32.0219 60.2951 28.6284C63.6886 25.2349 65.5951 20.6323 65.5951 15.8331V2.26172H52.0236C47.2245 2.26172 42.6219 4.16818 39.2284 7.56169C35.8348 10.9552 33.9284 15.5578 33.9284 20.357V33.9284ZM33.9284 33.9284L52.0236 15.8331M33.9284 47.4998L15.8331 29.4046",
    stroke: "#46973B",
    strokeWidth: 6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_18110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.8571,
    height: 67.8571,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorativeGreenery);
export default __webpack_public_path__ + "static/media/decorative_greenery.9a3c0e719c8720abee1d27dce6fab29a.svg";
export { ForwardRef as ReactComponent };